module.exports = __webpack_public_path__ + "static/img/product-bg.225ae14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-bg.png
// module id = jnN+
// module chunks = 0